/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Link } from "react-router-dom";

const Buttons = (props) => {
  return (
    <div className="main_btn">
      <Link to={props.href}>
        <span>{props.btnIcon}</span>
        <h4>{props.btntext}</h4>
      </Link>
    </div>
  );
};

export default Buttons;
